module.exports = "/images/knoume_bunner_sp.png?55b1c4c462d73510b3b93738bee2e25e";